<template>
    <li>
        <router-link
            to=""
            class="waves-effect open-modal-btn"
            @click.prevent="openModal"
        >
            <font-awesome-icon icon="key" fixed-width />
            Générer une clé ASIS
        </router-link>
    </li>

    <teleport to="body">
        <div v-if="showModal" class="modal-backdrop" @click.self="closeModal">
            <div class="modal_calcul" v-if="!modalLoading">
                <h3>Génération de clé ASIS</h3>

                <button
                    v-if="hasAsisKey"
                    class="btn btn-delete"
                    @click="deleteKey"
                    :disabled="isGenerating"
                >
                    <font-awesome-icon icon="key" />
                    {{ isDeleting ? 'Suppression en cours...' : 'Révoquer la clé actuelle' }}
                </button>

                <button
                    class="btn btn-generate"
                    @click="generateKey"
                    :disabled="isGenerating"
                >
                    <font-awesome-icon icon="key" />
                    {{ isGenerating ? 'Génération...' : 'Générer une clé' }}
                </button>


                <div v-if="generatedKey" class="result-section">
                    <input
                        :type="showKey ? 'text' : 'password'"
                        readonly
                        :value="generatedKey"
                        ref="keyInput"
                    />

                    <button class="icon-btn" @click="toggleShowKey" :title="showKey ? 'Cacher' : 'Voir'">
                        <font-awesome-icon :icon="showKey ? 'eye-slash' : 'eye'" />
                    </button>

                    <button class="icon-btn" @click="copyKey" title="Copier">
                        <font-awesome-icon :icon="['fas', 'clipboard']" />
                    </button>
                </div>

                <div class="modal-actions">
                    <button class="btn-close-calcul" @click="closeModal">Fermer</button>
                </div>
            </div>

            <div v-else class="modal_calcul">
                <p>Chargement...</p>
            </div>
        </div>
    </teleport>
</template>

<script>
import { proxyService } from "@/services";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faKey, faEye, faEyeSlash, faClipboard } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faKey, faEye, faEyeSlash, faClipboard);
export default {
    name: 'KeyAsis',
    data() {
        return {
            showModal: false,
            modalLoading: false,
            isGenerating: false,
            isDeleting: false,
            generatedKey: '',
            showKey: false,
            hasAsisKey : false,
        }
    },
    methods: {
        async openModal() {
            this.showModal = true
            this.generatedKey = ''
            this.showKey = false
            this.hasAsisKey = await proxyService.hasAsisKey();
        },
        closeModal() {
            this.showModal = false
            this.generatedKey = ''
            this.showKey = false
            this.isGenerating = false
        },

        async deleteKey() {
            this.isDeleting = true
            try {
                await proxyService.deleteAsisKey();
            } catch (e) {
                alert('Erreur lors de la suppression')
            } finally {
                this.isDeleting = false
                this.hasAsisKey = false;
                this.generatedKey = ''
            }
        },

        async generateKey() {
            this.isGenerating = true
            this.generatedKey = ''
            this.showKey = false
            try {
                var asisKey = await proxyService.generateAsisKey();
                this.generatedKey = asisKey.asisToken
            } catch (e) {
                alert('Erreur lors de la génération')
            } finally {
                this.isGenerating = false
                this.hasAsisKey = true
            }
        },
        toggleShowKey() {
            this.showKey = !this.showKey
        },
        copyKey() {
            if (!this.generatedKey) return
            navigator.clipboard.writeText(this.generatedKey)
                .then(() => alert('Clé copiée !'))
                .catch(() => alert('Erreur lors de la copie'))
        }
    },
}
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}

.modal_calcul {
    background: white;
    padding: 2rem;
    border-radius: 10px;
    width: 500px;
    max-width: 90%;
    box-shadow: 0 4px 20px rgba(0,0,0,0.2);
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
.btn {
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 20px;
    font-weight: bold;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    transition: background 0.2s ease-in-out;
}

.btn-delete {
    background: red;
}

.btn-generate {
    background: #e57525;
}

.btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}


.result-section {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.result-section input {
    flex-grow: 1;
    padding: 8px 12px;
    font-size: 1rem;
    border-radius: 6px;
    border: 1px solid #ccc;
    user-select: all;
}

.icon-btn {
    background: #486AAE;      /* fond bleu */
    border: none;
    cursor: pointer;
    color: white;            /* icône blanche */
    font-size: 1.3rem;
    padding: 6px 10px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    transition: background-color 0.3s ease;
}

.icon-btn:hover {
    background: #365691;     /* bleu plus foncé au hover */
}

.modal-actions {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-end;
}

.btn-close-calcul {
    background: #486AAE;
    border: none;
    padding: 10px 20px;
    color: white;
    border-radius: 20px;
    cursor: pointer;
}
</style>
